export const styles = theme => ({
    accordionDetails: {
        backgroundColor: "white"
    },
    section: {
        marginBottom: "20px",
        width: "100%"
    },
    root: {
        marginTop: 20,
        "& h6": {
            fontWeight: 700
        },
        "& svg": {
            float: "left",
            color: "#009",
            marginRight: 5,
            height: 18
        }
    },
    center: {
        textAlign: "center" as const
    },
    gap: {
        marginTop: 32,
        backgroundColor: "white"
    }
});
